import styled, { css } from 'styled-components';

import { BrandM } from '@sorare/core/src/atoms/typography';

const commonStyle = css`
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const firstStyle = css`
  background: var(--c-gradient-gold);
  -webkit-text-stroke: 0.5px #c07c26;
  ${commonStyle}
`;
const secondStyle = css`
  background: var(--c-gradient-silver);
  -webkit-text-stroke: 0.5px #757e80;
  ${commonStyle}
`;
const thirdStyle = css`
  background: var(--c-gradient-bronze);
  -webkit-text-stroke: 0.5px #ae6421;
  ${commonStyle}
`;

export const ColoredRanking = styled(BrandM)`
  &.rank-1 {
    ${firstStyle}
  }
  &.rank-2 {
    ${secondStyle}
  }
  &.rank-3 {
    ${thirdStyle}
  }
`;
